import React from 'react'

export const Education = () => {
  return (
    <div>
      <h2>Medical identity theft</h2>
      <h4>Medical identity theft is different from regular identity theft.</h4>
      <p>
        Medical identity theft is when someone steals or uses your personal
        information (like your name, Social Security number, or Medicare
        number), to submit fraudulent claims to Medicare and other health
        insurers without your authorization.{' '}
        <a
          href="https://oig.hhs.gov/fraud/consumer-alerts/medical-identity-theft/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Read more about medical identity theft.
        </a>
      </p>
    </div>
  )
}
